export enum AccountItemFieldsEnum {
  name = 'name',
  billingCurrencyCode = 'billingCurrencyCode',
}
